import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { GameEventsConstants } from "../../Constants/GameEventsConstants";
import { PlayerTurnConstant } from "../../Constants/PlayerTurnConstant";
import { GameLogic } from "../../Logic/GameLogic";
import { GameModel } from "../../Models/GameModel";
import { AnimationContents } from "../AnimationContents";
import { StickButtonController } from "./StickButtonController";

export class StickController extends AnimationBaseController{
    $model: GameModel;
    constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic
    ) {
        super("StickController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.GAMES_SCREEN_JSON,
            libraryName: "stick",
            childControllers: {
                StartButton: {
                    model: this.$model,
                    instanceName: "stick_button",
                    view: StickButtonController
                }
            },
            modelWatch: {

                currentTurn: (currentTurn: PlayerTurnConstant) => {
                    this.visible = this._gameLogic.isPlayerTurn && this.$model.isGameReady;
                },
                isGameReady: (isGameReady: boolean) => {
                    this.visible = isGameReady && this._gameLogic.isPlayerTurn;
                },
            },
            modelEvents: {
                [GameEventsConstants.hitStart]: () => {
                    this.visible = false;
                    this.$childControllers.get<StickButtonController>("StartButton").disable();
                },
                [GameEventsConstants.hitEnd]: () => {
                    this.visible = this._gameLogic.isPlayerTurn && this.$model.isGameReady;
                    this.$childControllers.get<StickButtonController>("StartButton").enable();
                }
            },
        }
    }
    protected onInitialize(): void {
        this.visible = this._gameLogic.isPlayerTurn && this.$model.isGameReady;
    }
    protected onResize(width: number, height: number, scale: number): void {
        this.x = width / scale / 2.8;
        this.y = height / scale / 3.7;
    }


}